import { SocketOptions, io } from 'socket.io-client'

export const connect = (opts: SocketOptions) => io({
  transports: ['websocket'],
  ...opts,
})
